import { Unit, UnitBaseTypes } from "../../Units";

function Metre({ exponent }) {
  return <Unit unit={UnitBaseTypes.metre} exponent={exponent} />;
}

export default Metre;
